<template>
  <form method="POST" class="form" @submit.prevent="onSubmit">
    <template v-if="isComplete">
      <div class="form__field">
        <BaseTitle
          size="l"
          is-medium
          v-html="'Спасибо!'"
        />
      </div>
      <div class="form__field">
        <BaseText v-html="'Ваше сообщение успешно отправлено :)'" is-block />
      </div>
      <div class="form__field">
        <BaseButton class="form__submit" text="Продолжить" @click="goNext" />
      </div>
    </template>
    <template v-else>
      <div class="form__field">
        <BaseTitle
          is-medium
          v-html="'Расскажите, какие практики были введены для решения проблемы в&nbsp;вашей компании?'"
        />
      </div>
      <div class="form__field">
        <BaseField
          ref="field_name"
          type="text"
          label="Имя"
          placeholder="Денис Абрамов"
          :value="name"
          :error="nameError"
          required
          @input="update('name', $event)"
        />
      </div>
      <div class="form__field">
        <BaseField
          ref="field_company"
          type="text"
          label="Компания"
          placeholder="ПАО «Норникель»"
          :value="company"
          :error="companyError"
          required
          @input="update('company', $event)"
        />
      </div>
      <div class="form__field">
        <BaseField
          ref="field_message"
          label="Ваш ответ"
          placeholder="Наша компания применяла схожие принципы"
          :value="message"
          :error="messageError"
          required
          @input="update('message', $event)"
        />
      </div>
      <div class="form__field">
        <BaseButton class="form__submit" type="submit" :disabled="isLoading" :is-loading="isLoading">
          Отправить
          <BaseIcon name="arrow" class="button__icon button__icon_after" />
        </BaseButton>
      </div>
      <div class="form__field">
        <BaseButton is-border text="Пропустить" class="form__submit" size="s" @click="goNext" />
      </div>
    </template>
  </form>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

import BaseField from '@/components/BaseField.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseIcon from '@/components/BaseIcon.vue';
import BaseText from '@/components/BaseText.vue';
import BaseTitle from '@/components/BaseTitle.vue';

export default {
  name: 'TheReviewForm',
  components: {
    BaseField,
    BaseButton,
    BaseIcon,
    BaseText,
    BaseTitle,
  },
  data() {
    return {
      name: '',
      company: '',
      message: '',
      nameError: '',
      companyError: '',
      messageError: '',
      isLoading: false,
      isComplete: false,
    };
  },
  methods: {
    ...mapActions(['sendReview']),
    ...mapMutations(['setReviewStatus']),
    update(name, value) {
      this[name] = value;
      this[`${name}Error`] = '';
    },
    onSubmit() {
      const isComplete = this.checkComplete();
      if (isComplete) {
        this.isLoading = true;
        this.sendReview({
          name: this.name,
          company: this.company,
          message: this.message,
        })
          .catch(console.error)
          .then(this.setComplete)
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    setComplete() {
      this.name = '';
      this.company = '';
      this.message = '';
      this.nameError = '';
      this.companyError = '';
      this.messageError = '';
      this.isComplete = true;
      this.setReviewStatus(true);
    },
    checkComplete() {
      if (!this.$refs.field_name.checkComplete()) {
        this.nameError = 'Давайте знакомиться, как вас зовут?';
        this.$refs.field_name.setFocus();
        return false;
      }
      if (!this.$refs.field_company.checkComplete()) {
        this.companyError = 'Расскажите где вы работаете';
        this.$refs.field_company.setFocus();
        return false;
      }
      if (!this.$refs.field_message.checkComplete()) {
        this.messageError = 'Неужели вы ничего не напишете?';
        this.$refs.field_message.setFocus();
        return false;
      }
      return true;
    },
    goNext() {
      this.$emit('next');
    },
  },
};
</script>
